import { http } from "../httpHandler";
import {
  TServerErrorResponse,
  EmailTemplateEntity,
  EmailTemplateType,
  ConversationPurposeEntity,
} from "@/types";
import { links } from "@/constants";

export const GET_ALL_EMAIL_TEMPLATES = "GET_ALL_EMAIL_TEMPLATES";
export const GET_DEFAULT_EMAIL_TEMPLATE = "GET_DEFAULT_EMAIL_TEMPLATE";

export const createEmailTemplate = async (
  data: Partial<EmailTemplateEntity>,
) => {
  try {
    const response = await http.post<EmailTemplateEntity>(
      links.emailTemplate.index,
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getEmailTemplate = async () => {
  try {
    const response = await http.get<EmailTemplateEntity>(
      links.emailTemplate.index,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getAllEmailTemplates = async ({
  type,
  purpose,
}: {
  type: EmailTemplateType;
  purpose?: ConversationPurposeEntity;
}) => {
  try {
    const response = await http.get<EmailTemplateEntity[]>(
      links.emailTemplate.index,
      {
        params: {
          type,
          purpose,
        },
      },
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const updateEmailTemplate = async (
  id: string,
  data: Partial<EmailTemplateEntity>,
) => {
  try {
    const response = await http.patch<EmailTemplateEntity>(
      links.emailTemplate.emailTemplateById(id),
      data,
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deleteEmailTemplate = async (id: string) => {
  try {
    const response = await http.delete<EmailTemplateEntity>(
      links.emailTemplate.emailTemplateById(id),
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getDefaultEmailTemplate = async ({
  type,
}: {
  type: EmailTemplateType;
}): Promise<EmailTemplateEntity> => {
  try {
    const response = await http.get<EmailTemplateEntity>(
      links.emailTemplate.default,
      {
        params: { type },
      },
    );

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const setDefaultEmailTemplate = async (id: string) => {
  try {
    const response = await http.put(links.emailTemplate.default, { id });

    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};
